module.exports = __webpack_public_path__ + "static/img/PU_Img4.cf45f0f1.jpg";